import axios from 'axios';
import { call } from 'redux-saga/effects';
// import { notificationActions } from '../reducers/notification.reducer';
// import { appActions } from '../reducers/app.reducer';

// function* toastNotifications(data) {
// 	try {
// 		if ('toast' in data) {
// 			if ('message' in data.toast) {
// 				yield put(notificationActions.addToast(data.toast));
// 			} else {
// 				const toastArr = Object.values(data.toast);

// 				for (var i = 0; i < toastArr.length; i++)
// 					yield put(notificationActions.addToast(toastArr[i]));
// 			}
// 		}
// 	} catch (e) {}
// }

// private API calls here
// https://github.com/axios/axios/issues/960
function* privateApi({
	endpoint,
	method = 'get',
	payload = {},
}) {
	payload = { ...payload };

	// let apiCallID = null;

	// if ('apiCallID' in payload) {
	// 	({ apiCallID } = payload);
	// 	delete payload.apiCallID;

	// 	yield put(appActions.apiCall({ id: apiCallID, timestamp: new Date().getTime() }));
	// }

	try {
		let options = {
			headers: {
				Accept: 'application/json',
				ContentType: 'application/x-www-form-urlencoded',
				// 'Access-Control-Allow-Headers': 'x-access-token',
				// ...headers,
			},
		};

		// const token = yield select(s => s.app.token);
		// if (token)
		// 	axios.defaults.headers['x-auth-token'] = token;

		// axios.defaults.headers['clientApp'] = yield select(s => s.app.clientApp);
		// axios.defaults.headers['clientEnv'] = yield select(s => s.app.clientEnv);

		let response = null;

		if (['post', 'put'].includes(method)) {
			response = yield call(
				axios[method],
				endpoint,
				payload,
				options,
			);
		} else if (method === 'get') {
			options = {
				...options,
				params: payload,
			};

			response = yield call(
				axios[method],
				endpoint,
				options,
			);
		}

		const { status, data } = response;

		// yield toastNotifications(data);

		switch (status) {
			case 200:
				return data;
		}
	} catch (err) {
		const {
			response: { data },
		} = err;
		// yield toastNotifications(data);
	} finally {
		// if (apiCallID)
		// 	yield put(appActions.apiCallComplete(apiCallID));
	}
}

export const privateCall = (...args) => call(privateApi, ...args);

export default function* axiosSaga() {
	// yield takeLatest(authActions.login, login);
}
